import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExternalQualityControlService {
  private readonly API_URL = `${environment.apiUrl}/es/ValidationAppraisals/Externals/Create`;

  constructor(private http: HttpClient) {}

  createExternalQualityControls(excelFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('excelFile', excelFile, excelFile.name);
    return this.http.post(this.API_URL, formData);
  }
}
